export default "__VITE_ASSET__pV0Am8jc__"